import { apolloClient } from "@/plugins/vue-apollo.js";

const updatePropertyType = async (_variables) => {
    // , limit, skip
  let responseFromApi;
  let variables = _variables;
  // debugger
  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/property/api/mutations/propertyType/update_property_type.graphql"),
      variables: variables,
      
      update: (store, { data }) => {
        const query = {
          query: require("@/property/api/queries/propertyType/property_type_query.graphql"),
          variables: {
            input: {
              limit: 10,
              skip: 0
            },
            filter: {
              searchKey: ''
            }
          },
        };
        let allPropertyType = store.readQuery(query);
        // debugger
        const findIndex = allPropertyType.getPropertyTypes.PropertyTypes.findIndex(
          (item) => item._id === data.updatePropertyType._id
        );
        findIndex !== -1 &&
          allPropertyType.getPropertyTypes.PropertyTypes.splice(
            findIndex,
            1,
            data.updatePropertyType
          );
        store.writeQuery({
          ...query,
          data: allPropertyType,
        });
      },
    })
    .catch((error) => {
      return error;
    });
  return responseFromApi;
};
export { updatePropertyType };
